const SELECTOR = '.detail__video';

document.querySelectorAll(SELECTOR).forEach((wrap) => {
  const overlay = wrap.querySelector('.detail__video-overlay');
  const iframe = wrap.querySelector('iframe');

  if (!overlay || !iframe) return;

  overlay.addEventListener('click', () => {
    try {
      const url = new URL(iframe.src);
      url.searchParams.set('autoplay', '1');
      iframe.src = url.toString();
    } catch (e) {
      iframe.src += (iframe.src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    }

    overlay.classList.add('is-hidden');

    overlay.addEventListener('transitionend', () => {
      overlay.style.display = 'none';
    }, { once: true });
  });
});
